var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      class: { "is-active": _vm.isActive, hamburger: true },
      attrs: { src: require("../../../src/assets/image/arrow.png") },
      on: { click: _vm.toggleClick }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }